import { UserPermission } from '../../users/models/user-permission.enum';

export const GenesysCloudMessageConversationsModulePermissions = [
  UserPermission.ConversationWebMessagingView,
  UserPermission.ConversationWebMessagingAccept
];
